"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNextDownOverlappingUserPhotoLayer = exports.getNextUpOverlappingUserPhotoLayer = exports.sortByZIndex = exports.ensureUniqueLayerZIndexes = void 0;
exports.updatePrintableLayerZIndex = updatePrintableLayerZIndex;
const UpdatePrintableLayerZIndex_1 = require("../../actions/UpdatePrintableLayerZIndex");
const either_1 = require("../../types/either");
const UserPhotoLayer_1 = require("../../models/layers/UserPhotoLayer");
const Printable_1 = require("../../models/printables/Printable");
const findPrintableGroup_1 = __importStar(require("./findPrintableGroup"));
const printables_1 = require("../printables");
const layers_1 = require("../layers");
function updatePrintableLayerZIndex(project, action) {
  const {
    printableId,
    layerId,
    direction
  } = action;
  const oldPrintable = (0, findPrintableGroup_1.findPrintableInProject)(project, printableId);
  const printableGroup = (0, findPrintableGroup_1.default)(project, printableId);
  const printableGroupIdx = project.printableGroups.findIndex(pg => pg.id === (printableGroup === null || printableGroup === void 0 ? void 0 : printableGroup.id));
  const printableIdx = project.printableGroups[printableGroupIdx].printables.findIndex(p => p.id === action.printableId);
  if (!oldPrintable) {
    return (0, either_1.left)(new Error(`unable to find printable in project: ${printableId}`));
  }
  const newPrintable = (0, Printable_1.updatePrintableVersion)(oldPrintable, action.timestamp);
  const activeLayer = (0, printables_1.findLayerInPrintable)(newPrintable, layerId);
  if (!activeLayer) {
    return (0, either_1.left)(new Error(`unable to find layer ${layerId} in printable: ${printableId}`));
  } else if (activeLayer.type !== 'user_photo') {
    return (0, either_1.left)(new Error(`Can't move non-user_photo layer ${layerId} forward or back`));
  }
  // sorted high to low
  const layersSortedByZIndex = (0, exports.sortByZIndex)(newPrintable.layers);
  const layersUniqueZIndexes = (0, exports.ensureUniqueLayerZIndexes)(layersSortedByZIndex);
  const userPhotoLayers = layersUniqueZIndexes.filter(UserPhotoLayer_1.isUserPhotoLayer);
  const nextUpOverlappingPhotoLayer = (0, exports.getNextUpOverlappingUserPhotoLayer)(userPhotoLayers, activeLayer);
  const nextDownOverlappingPhotoLayer = (0, exports.getNextDownOverlappingUserPhotoLayer)(userPhotoLayers, activeLayer);
  if (direction === UpdatePrintableLayerZIndex_1.UPDATE_Z_INDEX_DIRECTION.FORWARD && nextUpOverlappingPhotoLayer) {
    const initialActiveLayerZIndex = activeLayer.zIndex;
    const initialNextUpZIndex = nextUpOverlappingPhotoLayer.zIndex;
    layersUniqueZIndexes.forEach(layer => {
      if (!(0, UserPhotoLayer_1.isUserPhotoLayer)(layer)) return;
      if (layer === nextUpOverlappingPhotoLayer) {
        nextUpOverlappingPhotoLayer.zIndex = initialNextUpZIndex - 1;
        return;
      }
      if (layer === activeLayer) {
        activeLayer.zIndex = initialNextUpZIndex;
        return;
      }
      if (layer.zIndex < initialNextUpZIndex && layer.zIndex > initialActiveLayerZIndex) layer.zIndex--;
    });
  } else if (direction === UpdatePrintableLayerZIndex_1.UPDATE_Z_INDEX_DIRECTION.BACK && nextDownOverlappingPhotoLayer) {
    const initialActiveLayerZIndex = activeLayer.zIndex;
    const initialNextDownZIndex = nextDownOverlappingPhotoLayer.zIndex;
    layersUniqueZIndexes.forEach(layer => {
      if (!(0, UserPhotoLayer_1.isUserPhotoLayer)(layer)) return;
      if (layer === nextDownOverlappingPhotoLayer) {
        nextDownOverlappingPhotoLayer.zIndex = initialNextDownZIndex + 1;
        return;
      }
      if (layer === activeLayer) {
        activeLayer.zIndex = initialNextDownZIndex;
        return;
      }
      if (layer.zIndex > initialNextDownZIndex && layer.zIndex < initialActiveLayerZIndex) layer.zIndex++;
    });
  }
  newPrintable.layers = layersUniqueZIndexes.sort(layers_1.compareByReadingOrder);
  const updatedEntities = [newPrintable];
  project.printableGroups[printableGroupIdx].printables[printableIdx] = newPrintable;
  updatedEntities.push(project);
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities
  });
}
;
const ensureUniqueLayerZIndexes = layers => {
  // zIndexes will always start with the length of the array and descend to 1 by the last item
  return layers.map((layer, i) => {
    layer.zIndex = layers.length - i;
    return layer;
  });
};
exports.ensureUniqueLayerZIndexes = ensureUniqueLayerZIndexes;
const sortByZIndex = layers => {
  // non-user_photo layers always on top;
  return [...layers].sort((a, b) => {
    if (!(0, UserPhotoLayer_1.isUserPhotoLayer)(a) && !(0, UserPhotoLayer_1.isUserPhotoLayer)(b)) return 0;
    if (!(0, UserPhotoLayer_1.isUserPhotoLayer)(a)) return -1;
    if (!(0, UserPhotoLayer_1.isUserPhotoLayer)(b)) return 1;
    return b.zIndex - a.zIndex;
  });
};
exports.sortByZIndex = sortByZIndex;
const areOverlapping = (layerA, layerB) => {
  return layerA.x < layerB.x + layerB.width // aLeft crosses bRight
  && layerA.x + layerA.width > layerB.x // aRight crosses aLeft
  && layerA.y < layerB.y + layerB.height // aTop crosses bBottom
  && layerA.y + layerA.height > layerB.y; // aBottom crosses bTop
};

const getOverlappingLayers = (sortedLayers, currentLayer) => {
  return sortedLayers.filter(potentialOverlappingLayer => {
    return (0, UserPhotoLayer_1.isUserPhotoLayer)(potentialOverlappingLayer) && potentialOverlappingLayer.id !== currentLayer.id && areOverlapping(potentialOverlappingLayer, currentLayer);
  });
};
const getNextUpOverlappingUserPhotoLayer = (layers, currentLayer) => {
  const overlappingLayers = getOverlappingLayers(layers, currentLayer);
  return overlappingLayers.reverse().find(overlapping => (overlapping === null || overlapping === void 0 ? void 0 : overlapping.zIndex) > (currentLayer === null || currentLayer === void 0 ? void 0 : currentLayer.zIndex));
};
exports.getNextUpOverlappingUserPhotoLayer = getNextUpOverlappingUserPhotoLayer;
const getNextDownOverlappingUserPhotoLayer = (layers, currentLayer) => {
  const overlappingLayers = getOverlappingLayers(layers, currentLayer);
  return overlappingLayers.find(overlapping => (overlapping === null || overlapping === void 0 ? void 0 : overlapping.zIndex) < (currentLayer === null || currentLayer === void 0 ? void 0 : currentLayer.zIndex));
};
exports.getNextDownOverlappingUserPhotoLayer = getNextDownOverlappingUserPhotoLayer;